module.exports = __webpack_public_path__ + "fonts/74ece21.eot";